import {observer} from 'mobx-react';
import {calendarDate} from 'shared/tools';
import {FormattedMessage} from 'react-intl';
import NmbrUpdateFactory from './NmbrUpdateFactory';
import RetroactiveChangesWarning from './RetroactiveChangesWarning';

const ChangeInPayroll = observer(({nmbrUpdate}) => {
  return (
    <div>
      <div className='flex align-items-middle mb2'>
        <div className='h3 medium mr2'><FormattedMessage id='nmbr.updates.directory.Change in Payroll'/></div>
        <div className='h5 jumbo'>
          <FormattedMessage
            id='nmbr.updates.directory.ON_DATE'
            values={{date: calendarDate(nmbrUpdate.createdAt)}}
          />
        </div>
      </div>
      <RetroactiveChangesWarning nmbrUpdate={nmbrUpdate}/>
      <NmbrUpdateFactory nmbrUpdate={nmbrUpdate}/>
    </div>
  );
});

export default ChangeInPayroll;
